export class Group {
    groupname: string = '';
    description: string = '';
    members: any[] = [];
    not_editable: boolean = false;
}
